import { ActionIcon, Box, Button, Flex } from '@mantine/core';
import { IconLogout2 } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { userStore } from 'stores/global/RootStore';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

type Props = {
  className?: string;
};

export const LogoutButton: React.FC<Props> = ({ className }) => {
  const { menu } = useLkLayoutStore();
  const { logout, loadingStage } = userStore;

  if (menu.isOpen) {
    return (
      <Box p="xs">
        <Button
          className={className}
          variant="transparent"
          color="gray.6"
          leftSection={<IconLogout2 size={20} />}
          justify="flex-start"
          size="xs"
          loading={loadingStage.isLoading}
          onClick={logout}
          p="0"
          h={28}
        >
          Выйти
        </Button>
      </Box>
    );
  }

  return (
    <Flex p="xs" align="center">
      <ActionIcon
        className={className}
        variant="transparent"
        color="gray.6"
        loading={loadingStage.isLoading}
        onClick={logout}
        h={28}
      >
        <IconLogout2 size={20} />
      </ActionIcon>
    </Flex>
  );
};

export default observer(LogoutButton);
